import { render } from "./TransbankValidationView.vue?vue&type=template&id=f0162bfa&ts=true"
import script from "./TransbankValidationView.vue?vue&type=script&lang=ts"
export * from "./TransbankValidationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__